import { combineReducers } from 'redux';
import { GET_SCHOOLS, UPDATE_SETTINGS, GET_DEFAULT_SETTINGS } from './SchoolSettings/SchoolSettings.actions';
import { CHANGE_PASSWORD, UPDATE_PROFILE } from './AccountSettings/AccountSettings.actions';
import { SAVE_ORG_TAG, DELETE_ORG_TAG } from './ManageOrgTags/ManageOrgTags.actions';
import {
  GET_INVITED_USERS,
  GET_ORG_USERS,
  CANCEL_INVITE_USER,
  INVITE_USER_TO_ORG,
  ACTIVATE_ACCOUNT,
  DEACTIVATE_ACCOUNT,
  UPDATE_USER_PROFILE,
  RESET_USER_PASSWORD,
  RESEND_INVITE_USER,
} from './ManageUsers/ManageUsers.actions';
import { ASYNC_ERROR, ASYNC_FINISH, ASYNC_START } from '../../common';

const staticLoadingMsg = {
  [GET_SCHOOLS]: 'Getting schools...',
  [GET_DEFAULT_SETTINGS]: 'Getting settings...',
  [UPDATE_SETTINGS]: 'Updating settings...',
  [CHANGE_PASSWORD]: 'Changing password...',
  [UPDATE_PROFILE]: 'Updating profile...',
  [GET_INVITED_USERS]: "Getting district's invited users...",
  [GET_ORG_USERS]: "Getting district's Users...",
  [CANCEL_INVITE_USER]: 'Canceling invite...',
  [INVITE_USER_TO_ORG]: 'Inviting user to district...',
  [ACTIVATE_ACCOUNT]: "Activating user's account...",
  [DEACTIVATE_ACCOUNT]: "Deactivating user's account...",
  [UPDATE_USER_PROFILE]: "Updating user's profile...",
  [RESET_USER_PASSWORD]: "Resetting user's password...",
  [RESEND_INVITE_USER]: "Resending user's invitation...",
  // GET_ORG_TAGS is intentionally NOT here: the org tags read is a plain callable that
  // populates the Manage Tags table only, but this loadingMsg array gates the WHOLE
  // Settings body behind one spinner. Letting tags push into it blocked every settings
  // screen on a "Getting tags..." fetch. Tags now load in the background (they persist
  // in Redux and ManageOrgTags renders its own list as they arrive).
  [SAVE_ORG_TAG]: 'Adding tags...',
  [DELETE_ORG_TAG]: 'Deleting tag...',
};

const loadingMsg = (state = [], action) => {
  switch (action.type) {
    case ASYNC_START:
      if (action.model && staticLoadingMsg[action.model]) {
        state.push(staticLoadingMsg[action.model]);
        return state.slice();
      }
      return state;
    case ASYNC_ERROR:
    case ASYNC_FINISH:
      if (
        [
          GET_SCHOOLS,
          GET_DEFAULT_SETTINGS,
          UPDATE_SETTINGS,
          CHANGE_PASSWORD,
          UPDATE_PROFILE,
          GET_INVITED_USERS,
          GET_ORG_USERS,
          CANCEL_INVITE_USER,
          INVITE_USER_TO_ORG,
          ACTIVATE_ACCOUNT,
          DEACTIVATE_ACCOUNT,
          UPDATE_USER_PROFILE,
          RESET_USER_PASSWORD,
          RESEND_INVITE_USER,
          SAVE_ORG_TAG,
          DELETE_ORG_TAG,
        ].includes(action.model)
      ) {
        return state.filter((msg) => msg !== staticLoadingMsg[action.model]);
      }
      return state;
    default:
      return state;
  }
};

export const _reducer = combineReducers({
  loadingMsg,
});

export default 'Settings.reducers.js';
